// eslint-disable-next-line import/prefer-default-export
export enum PaymentProviderAccessorType {
	COMPANY = "company",
	PROVIDER = "provider",
	TAXI_SERVICE = "taxiService",
}
